import { currencies } from '@worldcoo/monolith/iso/4217';
import { generateImagePath } from '@worldcoo/shared/utils';

export const languageOptions = [
	{ value: 'CAT', label: 'Catalan' },
	{ value: 'EUS', label: 'Basque' },
	{ value: 'GLG', label: 'Galician' },
	{ value: 'ENG', label: '🇬🇧 English' },
	{ value: 'SPA', label: '🇪🇸 Spanish' },
	{ value: 'GER', label: '🇩🇪 German' },
	{ value: 'FRE', label: '🇫🇷 French' },
	{ value: 'KOR', label: '🇰🇷 Korean' },
	{ value: 'CHI', label: '🇨🇳 Chinese' },
	{ value: 'JPN', label: '🇯🇵 Japanese' },
	{ value: 'POR', label: '🇵🇹 Portuguese' },
	{ value: 'RUS', label: '🇷🇺 Russian' },
	{ value: 'ITA', label: '🇮🇹 Italian' },
	{ value: 'DUT', label: '🇳🇱 Dutch' },
	{ value: 'GRE', label: '🇬🇷 Greek' },
];

export const currencyOptions = Object.values(currencies).map((currency) => ({
	value: currency.code,
	label: `${currency.code} - ${currency.name}`,
}));

export function generateImageSrc(src: string, opts?: { height?: number; width?: number }): string {
	if (!import.meta.env.VITE_CDN_URL) return src;

	return import.meta.env.VITE_CDN_URL + generateImagePath(src, opts);
}

export const getLogoImageSize = (portalId: string) => ({
	height:
		portalId === 'awwg'
			? 72
			: portalId === 'generaloptica'
				? 72
				: portalId === 'maxsupermercati'
					? 72
					: portalId === 'eroski'
						? 60
						: portalId === 'familasicilia'
							? 60
							: portalId === 'fundacionrealmadrid'
								? 60
								: portalId === 'portaventura'
									? 60
									: 50,
});
